export const LOADING_MARKETINGLEADS = "LOADING_MARKETINGLEADS";
export const GET_MARKETINGLEADS = "GET_MARKETINGLEADS";
export const GET_MARKETINGLEADS_ID = "GET_MARKETINGLEADS_ID";
export const POST_MARKETINGLEADS_ID = "POST_MARKETINGLEADS_ID";
export const DELETE_MARKETINGLEADS = "DELETE_MARKETINGLEADS";
export const UPDATE_MARKETINGLEADS = "UPDATE_MARKETINGLEADS";
export const CONVERT_TO_SALES = "CONVERT_TO_SALES";